module.exports = __webpack_public_path__ + "img/qushangwang2.e707dfeb.png";